import Vue from 'vue'
import App from './components/App'
import './css/main.less'

new Vue({
  el: '#app',
  render: h => h(App)
})
